/* Pasform - close on outisde click */
var PDP__measurementsDropdown = (function () {
    var dropdown = document.querySelector('wdn-dropdown[data-id="model_mesaurements"]');
    if (!dropdown) return;
    var triggers = dropdown.querySelectorAll('.model_mesaurements-trigger');
    var dropdownInner = dropdown.querySelector('.product-measurements-bg');
    if (!dropdownInner) return;

    // Handlers
    var onInnerBlur = function () {
      dropdown.setInactive();

      triggers.forEach(function (elem) {
        elem.setAttribute('data-pointer-events-none', '');
      });

      setTimeout(function () {
        triggers.forEach(function (elem) {
          elem.removeAttribute('data-pointer-events-none');
        });
      }, 500);
    };

    var onTriggerClick = function () {
      if (dropdown.isActive == false) {
        dropdown.setActive();
        dropdownInner.focus();
      }
    };

    // Listeners
    dropdownInner.addEventListener('blur', onInnerBlur);

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', onTriggerClick);
    });
  })();



var PDP__onBlankAddToCartClick =  (function() {

    var btn = document.querySelector('[data-pdp-form-submit]');
    var productForm = btn.closest('wdn-product-form');
    
    function expandIt() {
      
      var variantSelect = productForm.querySelector('wdn-variant-select');
      variantSelect.expandContainer();
    }

    function openModalVariant() {
      var variantSelect = productForm.querySelector('wdn-modalvariant-trigger');
      variantSelect.click();
    }
    
    btn.addEventListener('click', (event) => {
      if (btn.getAttribute('data-pdp-form-options-size') == '1') {
        var actualCta = btn.querySelector('[data-form-submit="product_page"]');

        if (actualCta.getAttribute('data-state') == 'blank') {
          if (window.innerWidth >= 880) {
            expandIt();
            return;
          }

          openModalVariant();
        }
      }
    });
    
  })();